import { Activity } from "interfaces/ActivityInterfaces";
import { useLocalization } from 'hooks/useLocalization';
import { getSingularOrPluralCode } from 'utils/formatUtils';
import { Button, Box, Alert, Typography } from '@mui/material';
import { AddShoppingCart as AddShoppingCartIcon, AccessTime as AccessTimeIcon } from '@mui/icons-material';

interface ActivityDurationProps {
	activity: Activity;
	short?: boolean;
}

function ActivityDuration({ activity, short }: ActivityDurationProps) {
	const { getStr } = useLocalization();

	let durationStr: string = ''; 

	if (activity.duration.days > 1) {
		durationStr += `${activity.duration.days} ${getStr(short ? 'day_ABBREV' : getSingularOrPluralCode(activity.duration.days, 'day', 'days'))}`;
		if (activity.duration.hours || activity.duration.minutes) {
			durationStr += ', ';
		}
	}

	if (activity.duration.days === 1 && activity.duration.hours > 0) {
		durationStr += `${activity.duration.hours} ${getStr(short ? 'hour_ABBREV' : getSingularOrPluralCode(activity.duration.hours, 'hour', 'hours'))}`;
		if (activity.duration.minutes) {
			durationStr += ', ';
		}
	}

	if (activity.duration.days === 1 && activity.duration.minutes > 1) {
		durationStr += `${activity.duration.minutes} ${getStr(short ? 'minute_ABBREV' : getSingularOrPluralCode(activity.duration.minutes, 'minute', 'minutes'))}`;
	}
	
	return(
		<>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1
				}}
			>
				<AccessTimeIcon fontSize="small" />
				{durationStr}
			</Box>
		</>
	);
}

export default ActivityDuration;